export default __webpack_public_path__ + "static/media/img1.e6da962d.png";